import { color, Common, device } from '@stockbit/ui';
import Image from 'global/Image';
import styled, { css } from 'styled-components';

const { Flex, Text } = Common;

interface TitleContentProps {
  hasMoreLine?: boolean;
}

const TextWithClamp = styled(Text)`
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;

`;

const NewsWrapper = styled(Flex).attrs({
  justify: 'space-between',
  as: 'a',
})`
  gap: 10px;
  position: relative;
  width: 100%;
  cursor: pointer;

  @media ${device.tablet} {
    gap: 40px;
  }
`;

const ContentBox = styled(Flex).attrs({
  direction: 'column',
  justify: 'space-between',
})`
  position: relative;
  width: 100%;
  gap: 4px;

  .content-text {
    text-overflow: ellipsis;
    overflow: hidden;
    display: none;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    font-size: 13px;
  }

  @media ${device.tablet} {
    gap: 8px;

    .content-text {
      display: -webkit-box;
    }
  }
`;

const TitleContent = styled(TextWithClamp) <TitleContentProps>`
  line-height: 24px;
  -webkit-line-clamp: 3;

  @media ${device.laptop} {
    -webkit-line-clamp: 2;
    ${({ hasMoreLine }) => hasMoreLine && css`-webkit-line-clamp: 3`}
  }
`;

const ThumbnailBox = styled(Flex).attrs({ justify: 'space-between' })`
  height: 90px;
  min-width: 120px;  
  position: relative;
  width: 120px;
  background-color: #F7F7F7;
  border-radius: 6px;
`;

const Thumbnail = styled(Image)`
  border-radius: 6px;
  height: 100%;
  object-fit: cover;
  object-position: center top;
  width: 100%;
`;

export {
  ContentBox,
  NewsWrapper,
  Thumbnail,
  ThumbnailBox,
  TitleContent
}
